import React, { useEffect, useCallback, useState } from 'react';
import { AccordionItem, AccordionHeader, AccordionBody, Spinner } from 'reactstrap';
import Markdown from 'react-markdown';

import axios from 'axios';

const generateAiSummaryService = async (route) => {
  const response = await axios({
    method: 'patch',
    url: route,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });
  return response;
};

const routes = () => {
  return {
    default: {
      generateAiSummaryPath: Routes.generate_ai_summary_versioner_document_comparison_path
    },
    portal: {
      generateAiSummaryPath: Routes.generate_ai_summary_portal_versioner_document_comparison_path
    }
  }
}

const getRoutes = (props) => {
  const {
    helpers: {
      isPortalContext
    }
  } = props

  let context = 'default';

  if(isPortalContext){
    context = 'portal';
  }
  return routes()[context];
}

const getRequestParams = props => {
  const {
    comparison,
    configuration,
    helpers: {
      isPortalContext
    }
  } = props

  let requestParams = {
    id: comparison?.id
  }

  if(isPortalContext){
    requestParams = {
      tenant: configuration?.tenant,
      id: comparison?.id
    }
  }

  return requestParams;
}

const VersionerDocumentComparisonSidebarAiSummaryContainer = (props) => {
  const {
    comparison,
    currentItem,
    previousItem,
    callbacks: {
      callbackOnSetThread: callbackOnSetThread
    }
  } = props;

  const [messages, setMessages] = useState({content: '', color: ''});

  const {
    generateAiSummaryPath
  } = getRoutes(props);

  const defaultRequestParams = getRequestParams(props);

  const generateAiSummary = useCallback(() => {
    const route = generateAiSummaryPath(
      {
        ...defaultRequestParams,
        format: "json", _options: true
      }
    )

    generateAiSummaryService(route).then(response => {
      if(response.status === 200){
        callbackOnSetThread(prevState => {
          return {
            ...prevState,
            items: _.map(prevState?.items, item => {
              if(item?.id === currentItem?.id){
                return {
                  ...item,
                  current_comparison: response.data
                }
              }
              return item;
            })
          }
        });
      }
    }).catch(error => {
      setMessages({content: 'El servicio no se encuentra disponible por favor intente mas tarde', color: 'danger'});
      console.error(error);
    });
  })

  useEffect(() => {
    if(comparison && !comparison?.ai_summary && previousItem){
      generateAiSummary();
    } else if(comparison && !previousItem) {
      setMessages({content: 'No se puede generar el resumen de cambios porque no hay un documento para comparar', color: 'info'});
    }
  }, [comparison?.ai_summary])

  const renderLoading = () => {
    return (
      <div className='d-flex justify-content-center align-items-center w-100 h-100' style={{ backgroundColor: 'white', minHeight: 300 }}>
        <Spinner color="primary" />
      </div>
    )
  }

  const renderContent = () => {
    return (
      <div>
        <Markdown>{comparison?.ai_summary}</Markdown>
      </div>
    )
  }

  const renderMessages = () => {
    return (
      <div className={`alert alert-${messages?.color}`} role="alert">
        {messages?.content}
      </div>
    )
  }

  const renderBody = () => {
    if (messages?.content) return renderMessages();
    if (comparison?.ai_summary) return renderContent();
    return renderLoading();
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="1">
        <h2 className="fs-6 fw-bold mb-0">
          <i className="fas fa-magic mr-2"></i>
          Resumen de cambios
          <small className="fw-bold d-block">
            Controldoc IA
          </small>
        </h2>
      </AccordionHeader>
      <AccordionBody
        accordionId="1"
      >
        <div style={{ height: '500px', overflowY: 'auto' }}>
          { renderBody() }
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default VersionerDocumentComparisonSidebarAiSummaryContainer;